import { takeLatest, all, delay, put } from 'redux-saga/effects'

import { makeURL } from 'mednet-util/src/router'

import {
  receiveAction,
  makeFetchEffect,
  receiveReducer,
} from '../cns-util/reducer'

export const FETCH_QUESTION_SEARCH_PLACEHOLDERS =
  'search/FETCH_QUESTION_SEARCH_PLACEHOLDERS'

export const HIGHLIGHT_SEARCH_HEADER = 'search/HIGHLIGHT_SEARCH_HEADER'

export function fetchQuestionSearchPlaceholders(specialtyId, limit, callback) {
  return {
    type: FETCH_QUESTION_SEARCH_PLACEHOLDERS,
    specialtyId,
    limit,
    requestId: `${specialtyId}-${limit}`,
    callback,
  }
}

export function highlightSearchHeader(value) {
  return {
    type: HIGHLIGHT_SEARCH_HEADER,
    value,
  }
}

function* watchFetch() {
  yield makeFetchEffect(
    takeLatest,
    FETCH_QUESTION_SEARCH_PLACEHOLDERS,
    (action) =>
      makeURL('search/getQuestionSearchPlaceholders', {
        specialtyId: action.specialtyId,
        limit: action.limit,
      })
  )
}

function* highlightSearchHeaderSaga(action) {
  const { value } = action

  if (!value) {
    return
  }

  yield delay(2000) // 2 seconds delay

  yield put(highlightSearchHeader(false))
}

function* watchHighlightSearchHeader() {
  yield takeLatest(HIGHLIGHT_SEARCH_HEADER, highlightSearchHeaderSaga)
}

export function* rootSaga() {
  yield all([watchFetch(), watchHighlightSearchHeader()])
}

const initialState = {
  search: {
    questionSearchPlaceholders: {},
  },
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case receiveAction(FETCH_QUESTION_SEARCH_PLACEHOLDERS): {
      return receiveReducer(state, action, () => ({
        questionSearchPlaceholders: {
          ...state.questionSearchPlaceholders,
          [action.specialtyId]: action.response,
        },
      }))
    }

    case HIGHLIGHT_SEARCH_HEADER: {
      return receiveReducer(state, action, () => ({
        highlightSearchHeader: action.value,
      }))
    }

    default:
      return state
  }
}
